import camelcaseKeys from "camelcase-keys";
import {
  getPageMessage,
  onDeleteBroadcast,
  onExportRecipients,
  onGetBroadcastDetail,
  onGetMessageDetail,
  onGetMessageFeature,
  onGetMessageInReviewDetail,
  onGetMessagePast,
  onGetMessageReview,
  onGetRecipientsDetailPage,
  onGetRecipientsFutureDetail,
  onHideMessageSpam,
  onReadMessage,
  onUpdateBroadcast,
  onUpdateMessage,
  onUpdateStatusMessage,
  sendMessage,
} from "services/apis/message";
import snakecaseKeys from "snakecase-keys";
import { listenFirestoreMessageEvent } from "useFirebase/useFireStore";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doGetPageMessage = createAsyncThunk(
  "message/doGetPageMessage",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    const result = await getPageMessage(request);
    if (!result) {
      return;
    }
    // Set page number
    dispatch(setPageNumber(result.data.pageNumber));
    // Set total elements
    dispatch(setTotalElements(result.data.totalElements));
    return result;
  }
);

export const doGetMessageEvent = createAsyncThunk(
  "message/doGetMessageEvent",
  async (params, { dispatch }) => {
    const { workspaceId, conversationId } = params;
    listenFirestoreMessageEvent(workspaceId, conversationId, dispatch);
  }
);

export const doSendMessage = createAsyncThunk(
  "message/doSendMessage",
  async params => {
    const request = snakecaseKeys(params);
    const result = await sendMessage(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doUpdateMessage = createAsyncThunk(
  "message/doUpdateMessage",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onUpdateMessage(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doReadAllMessage = createAsyncThunk(
  "message/doReadAllMessage",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onReadMessage(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doGetMessageInReviewPage = createAsyncThunk(
  "message/doGetMessageInReviewPage",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    const result = await onGetMessageReview(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return camelcaseKeys(result.data);
  }
);

export const doGetMessagePastPage = createAsyncThunk(
  "message/doGetMessagePastPage",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    const result = await onGetMessagePast(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return camelcaseKeys(result.data);
  }
);

export const doGetMessageFeaturePage = createAsyncThunk(
  "message/doGetMessageFeaturePage",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    const result = await onGetMessageFeature(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return camelcaseKeys(result.data);
  }
);

export const doGetMessageDetail = createAsyncThunk(
  "message/doGetMessageDetail",
  async params => {
    const result = await onGetMessageDetail(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doGetMessageViewDetail = createAsyncThunk(
  "message/doGetMessageViewDetail",
  async params => {
    const result = await onGetMessageDetail(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doGetMessageInReviewDetail = createAsyncThunk(
  "message/doGetMessageInReviewDetail",
  async params => {
    const result = await onGetMessageInReviewDetail(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doGetRecipientsDetailPage = createAsyncThunk(
  "message/doGetRecipientsDetailPage",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onGetRecipientsDetailPage(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doGetRecipientsFutureDetail = createAsyncThunk(
  "message/doGetRecipientsFutureDetail",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onGetRecipientsFutureDetail(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);
export const doGetBroadcastDetail = createAsyncThunk(
  "message/doGetBroadcastDetail",
  async params => {
    const result = await onGetBroadcastDetail(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doUpdateBroadcast = createAsyncThunk(
  "message/doUpdateBroadcast",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onUpdateBroadcast(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doDeleteBroadcast = createAsyncThunk(
  "message/doDeleteMessage",
  async params => {
    const result = await onDeleteBroadcast(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doUpdateStatusMessage = createAsyncThunk(
  "message/doUpdateStatusMessage",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onUpdateStatusMessage(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doHideMessageSpam = createAsyncThunk(
  "message/doHideMessageSpam",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onHideMessageSpam(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doExportRecipients = createAsyncThunk(
  "message/doExportRecipients",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onExportRecipients(request);
    if (!result) {
      return;
    }
    // if (result.payload) {
    //   const blob = new Blob(["\ufeff", result], {
    //     type: "text/csv;charset=utf-8",
    //   });
    //   saveAs(blob, result.payload);
    // }
    return result;
  }
);

const initialState = {
  isSaving: false,
  isRefresh: "",
  messageList: [],
  messageDetail: {},
  recipientsDetailList: [],
  isProgress: 0,
  fileUploadList: [],
  conversation: null,
  message: {},
};

const slice = createSlice({
  name: "message",
  initialState: initialState,
  reducers: {
    setConversation: (state, action) => {
      state.conversation = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setTotalElements: (state, action) => {
      state.totalElements = action.payload;
    },
    setNumberOfElements: (state, action) => {
      state.numberOfElements = action.payload;
    },
    setIsRefresh: (state, action) => {
      state.isRefresh = action.payload;
    },
    setProgress: (state, action) => {
      state.isProgress = action.payload;
    },
    setFileUpList: (state, action) => {
      state.fileUploadList = [...action.payload];
    },
    setMessageList: (state, action) => {
      state.messageList = [...action.payload];
    },
    addMessage: (state, action) => {
      state.message = action.payload;
    },
  },
  extraReducers: {
    [doSendMessage.pending]: state => {
      state.isSaving = true;
    },
    [doSendMessage.fulfilled]: state => {
      state.isSaving = false;
    },
    [doSendMessage.rejected]: state => {
      state.isSaving = false;
    },
    [doGetPageMessage.pending]: state => {
      state.isSaving = true;
    },
    [doGetPageMessage.fulfilled]: state => {
      state.isSaving = false;
    },
    [doGetPageMessage.rejected]: state => {
      state.isSaving = false;
    },
  },
});

const { reducer, actions } = slice;
const { setNumberOfElements, setPageNumber, setTotalElements } = actions;

export const {
  setIsRefresh,
  setMessageList,
  addMessage,
  setProgress,
  setFileUpList,
  setOldMessageId,
  setConversation,
} = actions;

export default reducer;

export const isSaving = createSelector(
  state => state.message.isSaving,
  isSaving => isSaving
);

export const getMessagesList = createSelector(
  state => state.message.messageList,
  messageList => messageList
);

export const numOfEls = createSelector(
  state => state.message.numberOfElements,
  numberOfElements => numberOfElements
);
export const isRefreshMessage = createSelector(
  state => state.message.isRefresh,
  isRefresh => isRefresh
);

export const messageEvent = createSelector(
  state => state.message.messageEvent,
  messageEvent => messageEvent
);

export const pageNumber = createSelector(
  state => state.message.pageNumber,
  pageNumber => pageNumber
);

export const totalEls = createSelector(
  state => state.message.totalElements,
  totalElements => totalElements
);

export const isProgressUpload = createSelector(
  state => state.message.isProgress,
  isProgress => isProgress
);

export const fileUpList = createSelector(
  state => state.message.fileUploadList,
  fileUploadList => fileUploadList
);

export const getMessage = createSelector(
  state => state.message.message,
  message => message
);
